<template>
  <div class="search cross-sellProducts">
    <div style="position: fixed;left: 0;right: 0;top: 0;z-index: 1;">
      <header style="padding: 0 0.11rem;">
        <form action="/">
          <van-search
            v-model="searchValue"
            placeholder="请输入商品名称"
            clearable
            maxlength="32"
            @search="search"
          />
        </form>
        <!--<span @click="cancel">取消</span>-->
      </header>
      <div class="pro_cate_list" v-if="categoryList && categoryList.length && categoryList.length > 0">
        <van-tabs @click="setCurrentSlide" v-model="activeIndex" line-width="0.24rem" line-height="0.02rem">
          <van-tab :class="{'swiper-slide':true}" v-for="(item, index) in categoryList" :name="item.id"
                   :title="item.name"
                   :key="index">
          </van-tab>
        </van-tabs>
        <van-tabs @click="setScreenSlide" class="van-tabs-border" title-active-color="#FC0324" title-inactive-color="#4B4B4B" v-model="screenIndex" line-width="0" line-height="0">
          <van-tab :class="{'swiper-slide':true}" v-for="(item, index) in screen" :name="item.id"
                   :title="item.name"
                   :key="index">
            <template #title>
              <div class="flex-ac">{{item.name}} <div class="jt-bor" :class="{'ascending': priceSort == 4, 'descending': priceSort == 5}" v-if="index == 2"></div></div>
            </template>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"
              class="my_scroller"

    >
      <van-checkbox-group v-model="result" @change="onChange">
        <van-cell-group class="cell-group">
          <van-cell class="cell" v-for="(item, index) of productList" :key="index" clickable>
            <template slot="default">
              <van-checkbox class="radio" :name="item.itemid" checked-color="#FC0324" @click="changeCheckBox(item, index)">
                <div class="title">
                  <img v-lazy="item.img_path">
                  <div class="right flex-1">
                    <p class="name">&nbsp;{{item.name.length > 26 ? item.name.slice(0, 26) : item.name}}</p>
                    <p class="price">
                      <label class="xian">
                        <sub>¥</sub>
                        <b>{{String(item.sales_price).slice(0, String(item.sales_price).indexOf('.'))}}</b>
                        <sup>{{String(item.sales_price).slice(String(item.sales_price).indexOf('.'), String(item.sales_price).length)}}</sup>
                      </label>
                      <span>￥{{item.cost_price}}</span></p>
                    <p class="num">
                      <span>已售{{parseFloat(item.sales_num) / 10000 >= 1 ? (parseInt(parseInt(item.sales_num) / 100) / 100).toFixed(2) + 'w' : item.sales_num}}</span>
                      <span>好评{{item.comment_num}}</span>
                    </p>
                  </div>
                </div>
              </van-checkbox>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </Scroller>
    <div class="footer footerIOS">
      <button class="submit" @click="submit">确定</button>
    </div>
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang, uniqueArray } from '../../assets/common/js/config'

export default {
  name: 'cross-sellProducts',
  components: {
    Scroller
  },
  data: function () {
    return {
      result: [],
      radio: '',
      activeIndex: '0',
      screenIndex: 0,
      priceSort: 0,
      categoryList: [],
      screen: [
        {
          name: '综合',
          id: 1
        },
        {
          name: '销量',
          id: 2
        },
        {
          name: '价格',
          id: 3
        }
      ],
      sort: 1,
      productList: [],
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      searchValue: '',
      associateditem: [],
      noDataText: '—— 客官，木有啦~ ——'
    }
  },
  computed: {
    swiper () {
      return this.$refs.swiper1.swiper
    }
  },
  mounted: function () {
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || (from.path == '/' && from.name != 'homePage')) { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        if (isWeixin()) fenxiang({path: 'cross-sellproducts'})
        vm.associateditem = vm.$store.state.chooseCrossSellProductItem ? vm.$store.state.chooseCrossSellProductItem : []
        vm.chooseCheckBox()
        vm.nowPage = 0
        vm.getData()
      })
    } else {
      next(vm => {
        if (isWeixin()) fenxiang({path: 'cross-sellproducts'})
        vm.associateditem = vm.$store.state.chooseCrossSellProductItem ? vm.$store.state.chooseCrossSellProductItem : []
        vm.chooseCheckBox()
        vm.nowPage = 0
        vm.getData()
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  watch: {
    productList: {
      handler () {
        this.watchProductList()
      },
      // 这里是关键，代表递归监听 productList 的变化
      deep: true
    }
  },
  methods: {
    watchProductList () {
      let productlist = this.associateditem, delproductlist = []
      this.productList.map(item => {
        if (item.ischecked == 1) {
          productlist.push(item)
        } else if (item.ischecked == 2) {
          delproductlist.push(item)
        }
      })
      if (productlist.length > 0) this.associateditem = uniqueArray(productlist, 'itemid')
      if (delproductlist.length > 0) {
        delproductlist.map(delitem => {
          this.associateditem.map((item, index) => {
            if (delitem.itemid == item.itemid) {
              this.associateditem.splice(index, 1)
            }
          })
        })
      }
      // console.log('this.associateditem', this.associateditem)
    },
    onChange (names) {
      this.result = names
    },
    changeCheckBox (item, index) {
      if (this.result.indexOf(item.itemid) >= 0) {
        this.productList[index].ischecked = 1
      } else if (item.ischecked == 1) {
        this.productList[index].ischecked = 2
      }
      this.watchProductList()
    },
    clickCheckbox (item) {},
    submit: function () {
      this.$store.commit('CHOOSE_CROSS_SELL_PRODUCT_ITEM', this.associateditem)
      this.$router.go(-1)
    },

    chooseCheckBox: function () {
      this.productList.map(item => {
        item.ischecked = 0
      })
      this.result = []
      this.associateditem.map(item => {
        this.productList.map(listitem => {
          if (item.itemid == listitem.itemid) {
            listitem.ischecked = 1
            this.result.push(item.itemid)
          }
        })
      })
    },
    search: function () {
      this.activeIndex = 0
      this.nowPage = 1
      this.productList = []
      this.getListData()
    },
    getData: function () {
      var urlNav = this.$ajax.getCategoryList_URL+'?cat_id=1'
      var that = this
      this.$customRequestAjax(urlNav).then(res => {
        if (res.data.code === 200) {
          that.categoryList = []
          that.categoryList.unshift({id: '0', name: '全部'})
          that.categoryList = that.categoryList.concat(res.data.catlist)
        }
      })
    },
    getListData: function () {
      var urlProduct = this.$ajax.getItemList_URL+'?cat_id=' + this.activeIndex
        + '&pageno=' + this.nowPage + '&pagesize=' + this.pagesize
        + '&keyword=' + this.searchValue.trim()
        + '&sort=' + this.sort
      var that = this
      this.$customRequestAjax(urlProduct).then(res => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.productList = res.data.itemlist
            that.refresh = false
          } else {
            that.productList = that.productList.concat(res.data.itemlist)
          }
          that.chooseCheckBox()
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },

    setCurrentSlide (index) {
      this.activeIndex = index
      this.nowPage = 1
      this.productList = []
      this.getListData()
    },
    setScreenSlide (index) {
      this.screenIndex = index
      if (this.screenIndex == 3) {
        if (this.priceSort == 0) {
          this.priceSort = 4
        } else if (this.priceSort == 4) {
          this.priceSort = 5
        } else if (this.priceSort == 5) {
          this.priceSort = 4
        }
      } else {
        this.priceSort = 0
      }
      this.sort = (this.screenIndex == 1 || this.screenIndex == 2) ? this.screenIndex : this.priceSort
      this.nowPage = 1
      this.productList = []
      this.getListData()
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.productList = []
      this.getListData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getListData()
      // }, 400)
    }
  }
}
</script>

<style scoped lang="scss">
  .cross-sellProducts {
    header {
      background: #ffffff;
    }
    .footer {
      padding: 0.1rem 0.11rem;
      background: #ffffff;
      position: fixed;
      width: 100%;
      bottom: 0;
      .submit {
        width: 100%;
        flex: 1;
        display: block;
        margin-bottom: 0.1rem;
        line-height: 0.43rem;
        background: linear-gradient(90deg, #FC0324 0%, #F63A66 100%);
        border: none;
        outline: none;
        color: #fff;
        font-size: 0.17rem;
        border-radius: 0.25rem;
      }
    }
  }
  .cell-group {
    background: transparent;
    .cell {
      margin: 0.1rem 0.11rem 0;
      width: auto;
      background: #fff;
      padding: 0.13rem 0.1rem;
      border-radius: 0.04rem;
      .radio {
        height: auto;
        width: 100%;
      }
      .title {
        display: flex;
        display: -webkit-flex;
        display: -ms-flex;
        display: -moz-flex;
        display: -o-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        ms-align-items: center;
        -o-align-items: center;
        img {
          width: 0.8rem;
          height: 0.8rem;
          margin-left: 0.07rem;
          margin-right: 0.07rem;
          flex-shrink: 0;
          -webkit-flex-shrink: 0;
          -moz-flex-shrink: 0;
          -o-flex-shrink: 0;
          -ms-flex-shrink: 0;
        }
        .right {
          .name {
            font-size: 0.13rem;
            color: #333333;
            line-height: 0.2rem;
            height: 0.4rem;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .price {
            color: #FC0324;
            font-size: 0.15rem;
            line-height: 0.13rem;
            .xian {
              color: #FC0324;
              font-size: 0;
              line-height: .2rem;
              b {
                font-size: .14rem;
                font-weight: 600;
              }
              sub {
                font-weight: normal;
                font-size: .12rem;
                vertical-align: baseline
              }
              sup {
                font-size: .11rem;
                vertical-align: baseline;
                font-weight: normal;
              }
            }
            span {
              color: #999999;
              font-size: 0.12rem;
              margin-left: 0.045rem;
              text-decoration: line-through;
            }
          }
          .num {
            overflow: hidden;
            span {
              color: #999999;
              font-size: 0.1rem;
              &:first-of-type {
                float: left;
              }
              &:last-of-type {
                float: right;
              }
            }
          }
        }
      }
    }
  }
  .van-tabs-border {
    &:before {
      content: '';
      display: block;
      height: 0.01rem;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background: #EAEAEA;
      z-index: 1;
    }
    .jt-bor {
      margin-left: 0.04rem;
      &:before, &:after {
        content: '';
        display: block;
        height: 0;
        width: 0;
        border: 0.04rem solid transparent;
        border-bottom-color: #CCCCCC;
        transform: scaleX(0.7);
      }
      &:after {
        margin-top: 0.02rem;
        border: 0.04rem solid transparent;
        border-top-color: #CCCCCC;
      }
      &.ascending {
        &:before {
          border-bottom-color: #333333;
        }
      }
      &.descending {
        &:after {
          border-top-color: #333333;
        }
      }
    }
  }
  .my_scroller {
    margin-top: 1.43rem;
  }
</style>
<style lang="scss">
  .cross-sellProducts {
    .van-cell-group {
      margin-top: 0;
    }
    .van-cell__value--alone {
      height: auto;
    }
    .van-checkbox__label {
      flex: 1;
    }
    .van-tabs__line {
      bottom: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/community/cross-sellProducts.vue